import { render, staticRenderFns } from "./ActivationBriefTaskDeliveryView.vue?vue&type=template&id=731165bf&scoped=true&"
import script from "./ActivationBriefTaskDeliveryView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTaskDeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefTaskDeliveryView.vue?vue&type=style&index=0&id=731165bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731165bf",
  null
  
)

export default component.exports